<template>
  <div>
    <multiselect
      v-model="selected"
      :options="options"
      :multiple="true"
      placeholder="Seleziona uno o più elementi"
      selectLabel="Premi invio per selezionare"
      selectedLabel	=	'Seleziona'
      deselectLabel	=	'Premi invio per rimuovere'
      label="name"
      track-by="name"
      :loading="isLoading"
       @input="notify"
    >
      <span slot="noResult">{{ $t("message.not_found_search") }}</span>
      <span slot="noOptions">Non ci sono risultati disponibili</span>
    </multiselect>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  components: {Multiselect},

  data() {
    return {
      selected: [],
      options: [ ],
      isLoading: true,
    };
  },

  props: ["value"],
  watch: {
    value: function (v2, v1) {
      this.selected = v2;
    },
  },

  methods: {
    notify: function (value) {
      this.$emit("input", this.selected);
    }
  },
  mounted() {
    const self = this;
      self.selected = self.value;
      self.isLoading = true;
        axios({
          method: "get",
          url: self.$url + "operations/categories",
                    params: {
                        main: 14,
                        lang: self.$config.getLanguage(),
                    },
          headers: self.$config.axiosHeaders(),
        })
          .then(function (response) {
            self.options = [ ...(response.data.data ?? [])];
            self.isLoading = false;
          })
          .catch(function (error) {
            self.isLoading = false;
          });

  },
};
</script>

<style scoped>
</style>
